//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniPopup from "@/components/uni-popup/uni-popup.vue"
export default {
  name: 'couponLine',
  props: {
    price: {
      type: Number,
      default: 0
    },
    ids:{
      type:String,
      default:''
    },
	// coupons:{
	// 	type:Array,
	// 	default(){
	// 		return []
	// 	}
	// }
    // changePrice: {
    //   type: Function,
    //   default () { }
    // },
	// coupons:{
	// 	type:Array,
	// 	default(){
	// 		return[]
	// 	}
	// }
  },
	data(){
		return{
		  showList: false,
		  chosenCoupon: -1,
		  disabledCoupons: [],
      childCouponCode: '',
      coupons:[],
		}
	},
	components: {uniPopup},
	computed: {
    couponPrice () {
      return this.chosenCoupon > -1 ? this.coupons[this.chosenCoupon].couponDenomination : 0
    }
  },
  created(){
   
  },
	mounted() {
		this.$nextTick(()=>{			
			this.getCoupon()
		})
	},
  watch: {
    price (val, old) {
      if (val < old) {
        if (this.chosenCoupon !== -1) {
          this.onChange(this.chosenCoupon)
        }
      }
    },
    ids(val) {
      this.getCoupon(val)
    }
  },
  methods: {
    yhjclick(){
      this.showList = true
    },
    onChange (index) {
      this.showList = false
			this.$emit('openCoupons',this.showList)
       if (index === -1 || this.coupons[index].useDoorsill <= this.price) {
        this.chosenCoupon = index
        if (index === -1) {
          this.$emit('changePrice',{couponDenomination:0,childCouponCode:'',productIds:[]})
        } else {
		  this.$emit('changePrice',this.coupons[index])
        }
      } else {
				this.$emit('changePrice',0,'')
				uni.showToast({
            title: '抱歉，未达到使用门槛价格！',
            icon:'none'
				});
        // this.changePrice(0, '', [])
        // Toast.fail('抱歉，未达到使用门槛价格')
      }
    },
		getCoupon (index) {
			let _this=this
		  this.$ajax({
		    method: 'post',
		    url: '/weChat/coupon/queryCouponByMember',
		    data: {
		      memberId: this.$store.state.userInfo.memberId,
		      productId: index
		    }
		  }).then(res=>{
        if (res.data) {
          let data = _this.renderCoupon(res.data)
          _this.coupons = data.filter(t => {
          return t.useType === 0
          })
        }	
      })
		},
		renderCoupon (data) {
		  return data.map(t => {
		    return {
		      ...t,
		      id: t.childCouponCode,
		      oringinId: t.id,
		      available: 1,
		      useType: t.useType,
		      discount: 0,
		      denominations: t.couponDenomination,
		      // originCondition: t.useDoorsill,
		      origin_condition: t.useDoorsill === 0 || t.useDoorsill === null ? '无使用门槛' : `满${t.useDoorsill}减${t.couponDenomination}`,
		      reason: '',
		      value: t.useDoorsill
		      // startAt: t.useValidStartDate / 1000,
		      // endAt: t.useValidEndDate / 1000
		    }
		  })
		},
		openCoupons(){
			this.showList=true
			this.$emit('openCoupons',this.showList)
		},
		stopPrevent(){
			
		}
  }
}
